import { getField, updateField } from "vuex-map-fields";

import API from "@/api";
import moment from "moment";

export const state = () => ({
  // table
  carga: {},
  cargas: [],
  loadingTable: false,
  // filtros
  selectedSearchFonte: null,
  selectedSearchDataset: null,
  selectedSearchDestino: null,
  selectedSearchJob: null,
  selectedSearchStatus: null,
  selectedDtRequest: [],
  statusMap: {},
  executorMap: {},
  periodicidadeMap: {},
  estrategiaMap: {},
  searchDataset: [],
  searchStatus: [],
  searchJob: [],
  // paginacao
  pagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
  },
  errosCargaPagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
    loading: false,
  },
  errorsCurrentPage: 1,
  successCargaPagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
    loading: false,
  },
  successCurrentPage: 1,
  errosCarga: [],
  sucessosCarga: [],
  currentPage: 1,
});

export const getters = {
  getField,
  formatDate: () => (value) => formatDate(value),
  formatStatus: (state) => (code) => formatStatus(state, code),
  formatExecutor: (state) => (code) => formatExecutor(state, code),
  formatPeriodicidade: (state) => (code) => formatPeriodicidade(state, code),
  formatEstrategia: (state) => (code) => formatEstrategia(state, code),
  getColor: () => (value) => getColor(value),
};

function getColor(value) {
  switch (value) {
    case "SUCCESS":
      return "green";
    case "ERROR":
      return "red";
    case "RUNNING":
      return "orange";
    default:
      return "grey";
  }
}

function formatDate(value) {
  return value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "-";
}

function formatStatus(state, enumCode) {
  if (Object.keys(state.statusMap).length === 0 || !state.statusMap[enumCode]) {
    return enumCode;
  } else {
    return state.statusMap[enumCode];
  }
}

function formatExecutor(state, enumCode) {
  if (
    Object.keys(state.executorMap).length === 0 ||
    !state.executorMap[enumCode]
  ) {
    return enumCode;
  } else {
    return state.executorMap[enumCode];
  }
}

function formatPeriodicidade(state, enumCode) {
  if (
    Object.keys(state.periodicidadeMap).length === 0 ||
    !state.periodicidadeMap[enumCode]
  ) {
    return enumCode;
  } else {
    return state.periodicidadeMap[enumCode];
  }
}

function formatEstrategia(state, enumCode) {
  if (
    Object.keys(state.estrategiaMap).length === 0 ||
    !state.estrategiaMap[enumCode]
  ) {
    return enumCode;
  } else {
    return state.estrategiaMap[enumCode];
  }
}

function mountSearchPayload(state) {
  const config = {
    params: new URLSearchParams(),
  };

  config.params.append("size", state.pagination.size);
  config.params.append("page", state.currentPage - 1);

  if (state.selectedSearchFonte) {
    config.params.append("dsFonte", state.selectedSearchFonte.toString());
  }

  if (state.selectedSearchDataset) {
    config.params.append("dsDataset", state.selectedSearchDataset.toString());
  }

  if (state.selectedSearchDestino) {
    config.params.append("dsDestino", state.selectedSearchDestino.toString());
  }

  if (state.selectedSearchJob) {
    config.params.append("dsJob", state.selectedSearchJob.toString());
  }

  if (state.selectedSearchStatus) {
    config.params.append(
      "dsStatusCarga",
      state.selectedSearchStatus.toString()
    );
  }

  if (state.selectedDtRequest) {
    if (state.selectedDtRequest.length === 1) {
      config.params.append("dtInicExec", state.selectedDtRequest[0]);
    } else if (state.selectedDtRequest.length === 2) {
      config.params.append("dtInicExec", state.selectedDtRequest[0]);
      config.params.append("dtFimExec", state.selectedDtRequest[1]);
    }
  }
  return config;
}

function objectToMap(status, objectName) {
  let map = {};
  status.forEach((elem) => {
    if (objectName == "fonte") {
      map[elem.dsFonte] = elem.label;
    } else if (objectName == "dataset") {
      map[elem.dsDataset] = elem.label;
    } else {
      map[elem.code] = elem.label;
    }
  });
  return map;
}

export const actions = {
  async get({ dispatch, state, commit, rootState }, payload) {
    commit("updateField", { path: "pagination.offset", value: 0 });

    commit("updateField", { path: "cargas", value: [] });
    commit("updateField", { path: "currentPage", value: 1 });

    const result = await API.axios.get(
      "/bff/api/v1/controle-cargas/cargas",
      mountSearchPayload(state)
    );
    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.totalElements > 0) {
      commit("updateField", { path: "currentPage", value: 1 });
    } else {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "pagination.totalPages", value: 0 });
      commit("updateField", { path: "pagination.offset", value: 0 });
    }

    // total number of items
    if (result.data.totalElements) {
      commit("updateField", {
        path: "pagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "pagination.totalPages",
        value: result.data.totalPages,
      });
    }
    if (result.data.content) {
      const cargas = result.data.content.map((carga) => {
        return {
          ...carga,
          porcentData:
            carga.qtdSrcTotal && carga.qtdLoadedSucces != null
              ? parseInt((carga.qtdLoadedSucces / carga.qtdSrcTotal) * 100)
              : null,
        };
      });
      commit("updateField", { path: "cargas", value: cargas });
    }

    commit("updateField", { path: "loadingTable", value: false });
    return state.cargas;
  },
  async getCargaById({ dispatch, state, commit, rootState }, payload) {
    const response = await API.axios.get(
      `/bff/api/v1/controle-cargas/cargas/${payload}`
    );

    if (response !== undefined && response.status === 200) {
      commit("updateField", { path: "carga", value: response.data });
    }
    return response;
  },
  async getPage({ state, commit, rootState }, payload) {
    commit("updateField", { path: "loadingTable", value: true });
    const result = await API.axios.get(
      "/bff/api/v1/controle-cargas/cargas",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.content) {
      // update table items
      const cargas = result.data.content.map((carga) => {
        return {
          ...carga,
          porcentData:
            carga.qtdSrcTotal && carga.qtdLoadedSucces != null
              ? parseInt((carga.qtdLoadedSucces / carga.qtdSrcTotal) * 100)
              : null,
        };
      });
      commit("updateField", { path: "cargas", value: cargas });
      commit("updateField", {
        path: "pagination.offset",
        value: result.data.pageable.offset,
      });
    }
    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },
  async getStatus({ dispatch, state, commit, rootState }, payload) {
    const result = await API.axios.get(`/bff/api/v1/controle-cargas/status`);
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", { path: "searchStatus", value: result.data });
      commit("updateField", {
        path: "statusMap",
        value: objectToMap(result.data),
      });
    }
    return result;
  },
  async getExecutor({ dispatch, state, commit, rootState }, payload) {
    if (state.executorMap && Object.keys(state.executorMap).length > 0) return;

    const result = await API.axios.get(
      `/bff/api/v1/controle-cargas/executores`
    );
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", {
        path: "executorMap",
        value: objectToMap(result.data),
      });
    }
    return result;
  },
  async getPeriodicidade({ dispatch, state, commit, rootState }, payload) {
    if (
      state.periodicidadeMap &&
      Object.keys(state.periodicidadeMap).length > 0
    )
      return;

    const result = await API.axios.get(
      `/bff/api/v1/controle-cargas/periodicidades`
    );
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", {
        path: "periodicidadeMap",
        value: objectToMap(result.data),
      });
    }
    return result;
  },
  async getEstrategia({ dispatch, state, commit, rootState }, payload) {
    if (state.estrategiaMap && Object.keys(state.estrategiaMap).length > 0)
      return;

    const result = await API.axios.get(
      `/bff/api/v1/controle-cargas/estrategias`
    );
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", {
        path: "estrategiaMap",
        value: objectToMap(result.data),
      });
    }
    return result;
  },

  async getErrorsPage({ dispatch, state, commit, rootState }, { idCarga }) {
    const params = new URLSearchParams();
    params.append("page", state.errorsCurrentPage - 1);
    params.append("size", state.errosCargaPagination.size);
    commit("updateField", {
      path: "errosCargaPagination.loading",
      value: true,
    });

    const config = {
      params,
    };

    const result = await API.axios.get(
      `/bff/api/v1/controle-cargas/cargas/${idCarga}/erros`,
      config
    );

    commit("updateField", {
      path: "errosCargaPagination.loading",
      value: false,
    });

    if (result.status === 200) {
      commit("updateField", { path: "errosCarga", value: result.data.content });
      commit("updateField", {
        path: "errosCargaPagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "errosCargaPagination.totalPages",
        value: result.data.totalPages,
      });
      commit("updateField", {
        path: "errosCargaPagination.offset",
        value: result.data.pageable.offset,
      });
    }

    return result;
  },

  async getSuccessPage({ dispatch, state, commit, rootState }, { idCarga }) {
    const params = new URLSearchParams();
    params.append("page", state.successCurrentPage - 1);
    params.append("size", state.successCargaPagination.size);

    commit("updateField", {
      path: "successCargaPagination.loading",
      value: true,
    });
    const config = {
      params,
    };

    const result = await API.axios.get(
      `/bff/api/v1/controle-cargas/cargas/${idCarga}/sucessos`,
      config
    );

    commit("updateField", {
      path: "successCargaPagination.loading",
      value: false,
    });

    if (result.status === 200) {
      commit("updateField", {
        path: "sucessosCarga",
        value: result.data.content,
      });
      commit("updateField", {
        path: "successCargaPagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "successCargaPagination.totalPages",
        value: result.data.totalPages,
      });
      commit("updateField", {
        path: "successCargaPagination.offset",
        value: result.data.pageable.offset,
      });
    }

    return result;
  },
};

export const mutations = {
  updateField,
  setItemsPerPage(state, payload) {
    state.pagination.size = payload;
  },
  // setLoadingPage(state, { path, value }) {
  //   if (path === "erro") {
  //     state.errosCargaPagination.loading = value;
  //   } else if (path === "sucesso") {
  //     state.successCargaPagination.loading = value;
  //   }
  // },
  setErroPageSize(state, pageSize) {
    state.errosCurrentPage = 1;
    state.errosCargaPagination.size = pageSize;
  },
  setSuccessPageSize(state, pageSize) {
    state.successCurrentPage = 1;
    state.successCargaPagination.size = pageSize;
  },
  resetPage(state) {
    state.errosCargaPagination = {
      size: 10,
      totalPages: 0,
      totalElements: 0,
      offset: 0,
      loading: false,
    };
    state.errorsCurrentPage = 1;

    state.successCargaPagination = {
      size: 10,
      totalPages: 0,
      totalElements: 0,
      offset: 0,
      loading: false,
    };

    state.successCurrentPage = 1;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
